// @flow
import * as types from './mutation-types'
import type { CardState } from './index'
import type { CardSummary } from '../../../types/card-summary'
import Vue from 'vue'
import type {FilterPair} from '../../../types/filter-pair'
import type {OrderPersonalReplacementCardItem} from '../../../types/order-personal-replacement-card-item'
import type {OrderAnonymousReplacementCardItem} from '../../../types/order-anonymous-replacement-card-item'

export default {
  [types.SET_RESULTS_FOR_CURRENT_FILTER]: (state: CardState, cards: CardSummary[]): void => {
    state.resultsForCurrentFilter = cards
  },
  [types.SET_TOTAL_NO_RESULTS_FOR_CURRENT_FILTER]: (state: CardState, count: number): void => {
    state.totalNoResultsForCurrentFilter = count
  },
  [types.SET_CURRENT_PAGE_NUMBER]: (state: CardState, { number }: { number: number }): void => {
    state.currentPageNumber = number
  },
  [types.SET_PAGE_SIZE]: (state: CardState, number: number): void => {
    if (number <= 0) {
      return
    }
    state.pageSize = number
    let noPages = Math.ceil(state.totalNoResultsForCurrentFilter / number)
    if (state.currentPageNumber >= noPages) {
      state.currentPageNumber = noPages - 1
    }
  },
  [types.SET_ORDER_BY]: (state: CardState, orderBy: ?string): void => {
    state.orderBy = orderBy
  },
  [types.SET_ORDER_DIRECTION]: (state: CardState, orderDirection: ?string): void => {
    state.orderDirection = orderDirection
  },
  [types.SET_FILTER_PAIR]: (state: CardState, filterPair: FilterPair): void => {
    Vue.set(state.filter, filterPair.key, filterPair.value)
  },
  [types.ADD_FORM_DATA_ITEM]: (
    state: CardState,
    formDataItem: OrderPersonalReplacementCardItem | OrderAnonymousReplacementCardItem
  ): void => {
    state.formData.push(formDataItem)
  },
  [types.SET_FORM_DATA_ITEM_PROPERTY]: (
    state: CardState,
    payload: { formDataItem: OrderPersonalReplacementCardItem | OrderAnonymousReplacementCardItem, property: string, value: mixed }
  ): void => {
    let formDataItem = payload.formDataItem
    formDataItem[payload.property] = payload.value

    const formDataItemIndex = state.formData.findIndex(storeFormDataItem => storeFormDataItem.cardId === formDataItem.cardId)
    Vue.set(state.formData, formDataItemIndex, formDataItem)
  },
  [types.SET_FORM_DATA_ITEM_CARD_HOLDER_DETAILS_PROPERTY]: (
    state: CardState,
    payload: { formDataItem: OrderPersonalReplacementCardItem, property: string, value: mixed }
  ): void => {
    let formDataItem = payload.formDataItem
    formDataItem.cardHolderDetails[payload.property] = payload.value

    const formDataItemIndex = state.formData.findIndex(storeFormDataItem => storeFormDataItem.cardId === formDataItem.cardId)
    Vue.set(state.formData, formDataItemIndex, formDataItem)
  },
  [types.DELETE_FORM_DATA_ITEM]: (state: CardState, cardId: number): void => {
    const formDataItemIndex = state.formData.findIndex(formDataItem => formDataItem.cardId === cardId)

    Vue.delete(state.formData, formDataItemIndex)
  },
  [types.DELETE_FORM_DATA]: (state: CardState): void => {
    state.formData = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order-replacement-card/mutations.js